import {Box, Button, Card, CardActions, CardContent, CardMedia, Container, TextField} from "@mui/material";
import verticalLogo from '../resources/images/logo.png';
import {useRef, useState} from "react";
import {useAuth} from "../store/AuthProvider";
import {Navigate} from "react-router-dom";

const AuthenticationPage = () => {
    const auth = useAuth();
    const emailElement = useRef('');
    const passwordElement = useRef('');
    const [emailIsValid, setEmailIsValid] = useState(true);
    const [passwordIsValid, setPasswordIsValid] = useState(true);

    if (auth.token) return <Navigate to='/admin/' />;
    const onLoginClickHandler = () => {
        const email = emailElement.current.value;
        const validateEmail = email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g);

        const password = passwordElement.current.value
        const validatePassword = password.trim() !== "";

        setEmailIsValid(validateEmail);
        setPasswordIsValid(validatePassword);

        if(validatePassword && validateEmail){
            auth.loginAction({email, password});
        }
    }

    const onInputHandler = element => {
        if (element === 'email') {
            setEmailIsValid(true);
        } else if (element === 'password') {
            setPasswordIsValid(true);
        }
    }

    const onInputKeyUpHandler = (e) => {
        if (e.key === 'Enter'){
            onLoginClickHandler();
        }
    }
    return <>
        <Container maxWidth='false' sx={{background: '#096939', backgroundImage: 'linear-gradient(45deg, #dfdfdf, #efefef)', height: '100vh', width: '100vw', overflow: 'hidden'}}>
            <Card sx={{minWidth: 312, maxWidth: '', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}>
                <CardMedia
                    sx={{borderRadius: 1, my: 4, mx: 'auto', p: '25px', width: 'calc(100% - 50px)', height: 'auto'}}
                    component="img"
                    alt="green iguana"
                    image={verticalLogo}
                />
                <CardContent sx={{ textAlign: 'center'}}>
                    <Box sx={{ mb: 2}}>
                        <TextField
                            id="email-input"
                            error={ !emailIsValid }
                            helperText={ emailIsValid ? "" : "Email non valida!" }
                            label="Email"
                            variant="outlined"
                            autoComplete="email"
                            inputRef={emailElement}
                            onInput={onInputHandler.bind(this, "email")}
                            onKeyUp={onInputKeyUpHandler}
                        />
                    </Box>
                    <Box>
                        <TextField
                            id="password-input"
                            error={ !passwordIsValid }
                            helperText={ passwordIsValid ? "" : "Inserire una password!" }
                            label="Password"
                            type="password"
                            variant="outlined"
                            autoComplete="current-password"
                            inputRef={passwordElement}
                            onInput={onInputHandler.bind(this, "password")}
                            onKeyUp={onInputKeyUpHandler}
                        />
                    </Box>
                </CardContent>
                <CardActions
                    sx={{mt: 1, justifyContent: 'flex-end', pb: '25px', px: '25px'}}
                >
                    <Button type='submit' variant='contained' onClick={onLoginClickHandler} >Login</Button>
                </CardActions>
            </Card>
        </Container>
    </>
};

export default AuthenticationPage;